<script setup lang="ts">
  import { provideMenuImport } from '@/composition/menu-import/menu-import-context';
  import type { IMenuImportContext } from '@/composition/menu-import/menu-import-context';

  /**
   * Provides the menu flow's context to content a page renders outside the
   * flow (the workspace actions in the page's top bar: Vue 2.7 has no
   * Teleport). The page keys it by the flow's `contextId`, so a remounted
   * flow gets a fresh bridge; the context itself must stay raw (`markRaw`),
   * or travelling as a prop would unwrap its refs.
   */
  const props = defineProps<{ context: IMenuImportContext }>();
  provideMenuImport(props.context);
</script>

<template>
  <div class="v2-menu-context-bridge">
    <slot />
  </div>
</template>

<style scoped lang="scss">
  .v2-menu-context-bridge {
    @apply tw-flex tw-min-w-0 tw-items-center;
  }
</style>
